export default {
  momentLocale: 'zh-tw',
  Timeline: {
    expand: '展開',
    fold: '收起',
  },
  Balloon: {
    close: '關閉',
    confirm: '確定',
    cancel: '取消',
  },
  Card: {
    expand: '展開',
    fold: '收起',
  },
  Calendar: {
    today: '今天',
    now: '此刻',
    ok: '確定',
    clear: '清除',
    month: '月',
    year: '年',
    prevYear: '上一年',
    nextYear: '下一年',
    prevMonth: '上個月',
    nextMonth: '下個月',
    prevDecade: '前十二年',
    nextDecade: '後十二年',
    yearSelectAriaLabel: '選擇年份',
    monthSelectAriaLabel: '選擇月份',
    format: {
      months: '1 月_2 月_3 月_4 月_5 月_6 月_7 月_8 月_9 月_10 月_11 月_12 月'.split('_'),
      shortMonths: '1 月_2 月_3 月_4 月_5 月_6 月_7 月_8 月_9 月_10 月_11 月_12 月'.split('_'),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      shortWeekdays: '日_一_二_三_四_五_六'.split('_'),
      veryShortWeekdays: '日_一_二_三_四_五_六'.split('_'),
      yearLabel: 'YYYY 年',
    },
  },
  DatePicker: {
    placeholder: '請選擇日期',
    datetimePlaceholder: '請選擇日期和時間',
    monthPlaceholder: '請選擇月',
    yearPlaceholder: '請選擇年',
    now: '此刻',
    selectTime: '選擇時間',
    selectDate: '選擇日期',
    ok: '確定',
    clear: '清除',
    startPlaceholder: '起始日期',
    endPlaceholder: '結束日期',
    hour: '時',
    minute: '分',
    second: '秒',
  },
  Dialog: {
    close: '關閉',
    ok: '確定',
    cancel: '取消',
  },
  Message: {
    closeAriaLabel: '關閉',
  },
  Pagination: {
    goTo: '前往',
    page: '頁',
    total: '第{current}頁，共{total}頁',
    labelPrev: '上一頁，目前第{current}頁',
    labelNext: '下一頁，目前第{current}頁',
    inputAriaLabel: '請輸入跳轉到第幾頁',
    selectAriaLabel: '請選擇每頁顯示幾筆',
    pageSize: '筆/頁',
  },
  Input: {
    clear: '清除',
  },
  Select: {
    selectPlaceholder: '請選擇',
    autoCompletePlaceholder: '請輸入',
    notFoundContent: '無選項',
    maxTagPlaceholder: '已選擇 {selected}/{total} 項',
  },
  Table: {
    empty: '沒有資料',
    ok: '確定',
    reset: '重設',
    asc: '升序',
    desc: '降序',
    expanded: '已展開',
    folded: '已折疊',
    filter: '篩選',
    selectAll: '全選',
  },
  TimePicker: {
    placeholder: '請選擇時間',
    startPlaceholder: '開始時間',
    endPlaceholder: '結束時間',
    clear: '清除',
    hour: '時',
    minute: '分',
    second: '秒',
  },
  Transfer: {
    items: '項',
    item: '項',
    moveAll: '移動全部',
    searchPlaceholder: '請輸入',
    moveToLeft: '撤銷選取的元素',
    moveToRight: '提交選取的元素',
  },
  Upload: {
    card: {
      cancel: '取消',
      addPhoto: '上傳圖片',
      download: '下載',
      delete: '刪除',
    },
    drag: {
      text: '點選或者拖曳檔案文件到虛線框內上傳',
      hint: '支援 docx、xls、PDF、rar、zip、PNG、JPG 等類型的檔案',
    },
    upload: {
      delete: '刪除',
    },
  },
  Search: {
    buttonText: '搜尋',
  },
  Tag: {
    delete: '刪除',
  },
  Rating: {
    description: '評分選項',
  },
};
